import styled, { css } from "styled-components";
import { isDiferentiatedBrands } from "../../../themes/themes";
import { getBrandStorage } from "../../../utils/getBrand";
import { rgba } from "polished";

const brand = getBrandStorage();

export const Wrapper = styled.div`
  width: 100%;
  margin-bottom: 12px;
`;

export const CounterText = styled.span`
  ${({ theme }) => css`
    font-size: 16px;
    font-weight: 400;
    height: 28px;
    font-family: "Poppins";
    color: #023566;
    padding-left: 10px;
  `}
`;

export const Container = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 600px;
`;
